const UrlSearchParams: URLSearchParams & {
    new (init?: string | URLSearchParams): URLSearchParams;
    // eslint-disable-next-line @typescript-eslint/no-var-requires
} = require('url-search-params');

export default UrlSearchParams;
